import { FileAttachment, TextDirection } from 'interface';

export interface __FileProps {
    maxSize?: number;
    fileType: string;
    label?: string;
    hint?: string;
    image?: FileAttachment;
    alt?: string;
    labelColor?: string;
    onDrop?(): void;
    onChange?(e?: FileAttachment[]): void;
    onRemove?(id?: number): void;
    color?: string;
    defaultValue?: FileAttachment[];
    counter?: number;
    dir?: TextDirection;
    required?: boolean;
    multiple?: boolean;
    ws: number;
    accessToken?: string;
}

export interface __FileRef {
    getValue: () => FileAttachment[] | undefined;
    setError: (text: string) => void;
}

export enum __FileType {
    file = '.pdf , .doc , .xlsx',
    image = '.jpg, .png , .gif',
    voice = '.mp3,.ogg',
    film = '.mkv , .mp4',
}
